module.exports = __webpack_public_path__ + "static/media/dish8.559ac802.jpg";